(() => { 'use strict'; const mobile = window.matchMedia('all'); const root = (document.getElementById('CollectionAjaxResult') || document.getElementById('SearchResults')); if (!root || !window.IntersectionObserver) return; const selector = '#CollectionSection template[data-plp-mobile-gallery], #SearchResults template[data-plp-mobile-gallery]'; const active = new Map(); const controllers = new WeakMap(); const selections = new WeakMap(); const mediaCache = new Map(); const pending = new Set(); let proximity, mutations, seen, visibility; const visibilityHandlers = new WeakMap(); function initialize(template, force = false) { if (!mobile.matches || !template.isConnected || active.has(template)) return; const card = template.parentElement; const mask = card.querySelector('.grid-product__image-mask'); const original = mask && mask.querySelector('.image-wrap, .grid__image-ratio'); if (!original) return; const nextSibling = original.nextSibling; const originalImage = original.querySelector('img.grid-product__image'); const gallery = template.content.firstElementChild.cloneNode(true); const track = gallery.querySelector('.plp-mobile-gallery__track'); let slides = Array.from(track.children); if (slides.length === 1 && !force) return; const previous = gallery.querySelector('.plp-mobile-gallery__arrow--previous'); const next = gallery.querySelector('.plp-mobile-gallery__arrow--next'); const status = gallery.querySelector('[role="status"]'); let index = 0, frame = 0, pointer = null, swiped = false, dragged = false, settleTimer = 0, retryVideo = null;   slides[0].append(original); template.after(gallery); const quickShop = mask.querySelector(".quick-product__btn"); if (quickShop) gallery.append(quickShop); const quickAdd = mask.querySelector('[data-plp-quick-add]'); if (quickAdd) gallery.append(quickAdd); mask.classList.add('plp-mobile-gallery-original'); function load(position) { const slide = slides[position]; const img = slide && slide.querySelector('img[data-image-url]'); if (!img) return; const url = width => { const imageUrl = new URL(img.dataset.imageUrl, window.location.href); imageUrl.searchParams.set('width', width); return imageUrl.href; }; img.sizes = Math.ceil(track.clientWidth) + 'px'; img.srcset = [180, 360, 540, 720, 900, 1080].map(width => `${url(width)} ${width}w`).join(','); img.src = url(540); img.removeAttribute('data-image-url'); } let playingSlide = null, cardVisible = false;
  function stopVideo() {
    if (!playingSlide) return;
    const player = playingSlide.querySelector('video, iframe');
    if (player) {
      if (player.tagName === 'VIDEO') {
        player.pause();
        player.removeAttribute('src');
        player.load();
      }
      player.remove();
    }
    playingSlide = null;
    retryVideo = null;
    clearTimeout(settleTimer);
  }
  function retryAfterSettle() {
    clearTimeout(settleTimer);
    if (!retryVideo) return;
    settleTimer = setTimeout(() => {
      const video = retryVideo;
      retryVideo = null;
      if (video && playingSlide && video.parentElement === playingSlide && cardVisible && slides[index] === playingSlide) {
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
      }
    }, 250);
  }
  function activateVideo(position) {
    const slide = slides[position];
    if (!cardVisible || !slide || !slide.dataset.videoType || playingSlide === slide) return;
    stopVideo();
    if (slide.dataset.videoType === 'hosted' && slide.dataset.videoSrc) {
      const video = document.createElement('video');
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.loop = true;
      video.controls = false;
      video.preload = 'none';
      const poster = slide.querySelector('img');
      if (poster) video.poster = poster.currentSrc || poster.src;
      video.src = slide.dataset.videoSrc;
      slide.append(video);
      playingSlide = slide;
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(() => { if (playingSlide === slide && cardVisible) { retryVideo = video; retryAfterSettle(); } });
    } else if (slide.dataset.videoType === 'external') {
      const id = encodeURIComponent(slide.dataset.videoId || '');
      const host = slide.dataset.videoHost;
      const src = host === 'youtube' ? 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&mute=1&playsinline=1' :
        host === 'vimeo' ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&muted=1&playsinline=1' : '';
      if (!src) return;
      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.title = 'Product video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      slide.append(iframe);
      playingSlide = slide;
    }
  }
  function update() {
    frame = 0;
    if (!track.clientWidth) return;
    const position = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
    load(position);
    if (swiped || position !== 0) { load(position - 1); load(position + 1); }
    if (position !== index) {
      stopVideo();
      index = position;
      slides.forEach((slide, i) => {
        slide.tabIndex = i === index ? 0 : -1;
        if (i === index) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      previous.disabled = index === 0;
      next.disabled = index === slides.length - 1;
      status.textContent = `Media ${index + 1} of ${slides.length}`;
    }
    activateVideo(position);
  }
 function navigate(offset, event) { event.preventDefault(); event.stopPropagation(); const destination = Math.max(0, Math.min(slides.length - 1, index + offset)); load(destination); track.scrollTo({ left: destination * track.clientWidth, behavior: 'instant' }); update(); } card.dataset.plpSwatchManaged = '';
 controllers.set(card, {
   replace(incoming, destination) {
     stopVideo(); cancelAnimationFrame(frame); frame = 0;
     pointer = null; dragged = false; swiped = false;
     slides = Array.from(incoming.content.querySelector('.plp-mobile-gallery__track').children);
     slides.forEach(slide => slide.setAttribute('href', destination));
     const firstImage = slides[0].querySelector('img');
     if (firstImage) firstImage.classList.add('grid-product__image');
     track.replaceChildren(...slides);
     track.scrollTo({ left: 0, behavior: 'instant' });
     index = -1;
     previous.hidden = next.hidden = slides.length < 2;
     if (slides.length < 2) { previous.style.display = next.style.display = 'none'; }
     else { previous.style.removeProperty('display'); next.style.removeProperty('display'); }
     gallery.setAttribute('aria-label', incoming.dataset.productTitle + ' media');
     update();
   }
 });
 previous.hidden = next.hidden = slides.length < 2;
 if (slides.length < 2) previous.style.display = next.style.display = 'none';
 previous.addEventListener("click", event => navigate(-1, event)); next.addEventListener('click', event => navigate(1, event)); track.addEventListener('pointerdown', event => { swiped = false; dragged = false; pointer = { x: event.clientX, y: event.clientY }; }, { passive: true }); track.addEventListener('pointermove', event => { if (!pointer) return; const x = event.clientX - pointer.x, y = event.clientY - pointer.y; if (Math.abs(x) > 10 && Math.abs(x) > Math.abs(y)) { swiped = true; dragged = true; load(index + (x < 0 ? 1 : -1)); } }, { passive: true }); track.addEventListener('scroll', () => { swiped = true; if (!frame) frame = requestAnimationFrame(update); retryAfterSettle(); }, { passive: true }); track.addEventListener('click', event => { if (dragged && event.detail !== 0) { event.preventDefault(); event.stopImmediatePropagation(); } pointer = null; dragged = false; }, true); visibilityHandlers.set(card, isVisible => {
    cardVisible = isVisible;
    if (cardVisible) activateVideo(index);
    else stopVideo();
  });
  visibility.observe(card);
  active.set(template, () => { visibility.unobserve(card); visibilityHandlers.delete(card); controllers.delete(card); delete card.dataset.plpSwatchManaged; const selection = selections.get(card); if (selection && selection.abort) selection.abort.abort(); stopVideo(); cancelAnimationFrame(frame); mask.insertBefore(original, nextSibling); if (originalImage) originalImage.classList.add('grid-product__image'); mask.classList.remove('plp-mobile-gallery-original'); if (quickShop) mask.prepend(quickShop); if (quickAdd) mask.prepend(quickAdd); gallery.remove(); }); } function discover(node) { if (!(node instanceof Element)) return; const templates = node.matches(selector) ? [node] : node.querySelectorAll(selector); templates.forEach(template => { if (seen.has(template)) return; seen.add(template); pending.add(template.parentElement); proximity.observe(template.parentElement); }); } function start() { seen = new WeakSet(); visibility = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const handler = visibilityHandlers.get(entry.target);
      if (handler) handler(entry.isIntersecting);
    });
  }, { threshold: 0 }); proximity = new IntersectionObserver(entries => { entries.forEach(entry => { if (!entry.isIntersecting) return; proximity.unobserve(entry.target); pending.delete(entry.target); const template = entry.target.querySelector('template[data-plp-mobile-gallery]'); if (template) initialize(template); }); }, { rootMargin: '250px 0px' }); mutations = new MutationObserver(records => { pending.forEach(card => { if (!card.isConnected) { proximity.unobserve(card); pending.delete(card); } }); active.forEach((cleanup, template) => { if (!template.isConnected) { cleanup(); active.delete(template); } }); records.forEach(record => record.addedNodes.forEach(discover)); }); mutations.observe(root, { childList: true, subtree: true }); discover(root); } function refresh() { if (proximity) proximity.disconnect(); if (mutations) mutations.disconnect(); active.forEach(cleanup => cleanup()); active.clear(); pending.clear(); if (visibility) visibility.disconnect(); if (mobile.matches) start(); } function productPath(value) {
  const url = new URL(value, location.href);
  if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) throw new Error('Invalid product URL');
  return url.pathname.replace(/\/$/, '').replace(/^.*(?=\/products\/)/, '');
}
function parseMedia(html) {
  const holder = document.createElement('template');
  holder.innerHTML = html;
  const template = holder.content.querySelector('template[data-plp-mobile-gallery]');
  const details = holder.content.querySelector('template[data-plp-product-details]');
  const quickAdd = holder.content.querySelector('template[data-plp-quick-add]');
  if (!template || !template.dataset.productId || !template.content.querySelector('.plp-mobile-gallery__slide img') || !details?.content.querySelector('[data-plp-price]') || !details.content.querySelector('[data-plp-badges]') || !quickAdd) throw new Error('Product data unavailable');
  template.productDetails = details.content;
  template.quickAdd = quickAdd.content;
  return template;
}
async function fetchMedia(destination, signal) {
  const url = new URL(destination, location.href);
  productPath(url.href);
  url.search = '';
  url.searchParams.set('section_id', 'plp-swatch-media');
  // Keep draft preview context when the storefront URL explicitly carries it.
  const preview = new URL(location.href).searchParams.get('preview_theme_id');
  if (preview) url.searchParams.set('preview_theme_id', preview);
  const key = url.href;
  if (mediaCache.has(key)) {
    const cached = mediaCache.get(key); mediaCache.delete(key); mediaCache.set(key, cached);
    return parseMedia(cached);
  }
  const response = await fetch(key, { credentials: 'same-origin', signal });
  if (!response.ok) throw new Error('Media request failed');
  const html = await response.text();
  const template = parseMedia(html);
  if (productPath(template.dataset.productUrl) !== productPath(destination)) throw new Error('Wrong product response');
  template.cacheKey = key; template.cacheHtml = html;
  return template;
}
function prepareOpening(template, width, signal) {
  const target = template.content.querySelector('.plp-mobile-gallery__slide img');
  const source = target && target.dataset.imageUrl;
  const image = document.createElement('img');
  if (!source) return Promise.reject(new Error('Opening image unavailable'));
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => finish(new Error('Image timed out')), 15000);
    const abort = () => finish(new Error('Selection cancelled'));
    function finish(error) {
      clearTimeout(timer); image.onload = image.onerror = null; signal.removeEventListener('abort', abort);
      if (error) reject(error); else {
        target.sizes = image.sizes; target.srcset = image.srcset; target.src = image.src;
        target.removeAttribute('data-image-url'); resolve();
      }
    }
    if (signal.aborted) return finish(new Error('Selection cancelled'));
    signal.addEventListener('abort', abort, { once: true });
    image.onload = () => finish(); image.onerror = () => finish(new Error('Image failed'));
    image.sizes = Math.ceil(width) + 'px';
    image.srcset = [180, 360, 540, 720, 900, 1080].map(w => {
      const url = new URL(source, location.href); url.searchParams.set('width', w); return url.href + ' ' + w + 'w';
    }).join(',');
    const url = new URL(source, location.href); url.searchParams.set('width', 540); image.src = url.href;
    image.removeAttribute('data-image-url');
  });
}
function selectionStatus(card, message) {
  let status = card.querySelector('[data-plp-selection-status]');
  if (!status) {
    status = document.createElement('span'); status.dataset.plpSelectionStatus = '';
    status.className = 'visually-hidden'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
    card.append(status);
  }
  status.textContent = message;
}
// Desktop hover commits the same complete product state as a mobile selection.
const desktopHover = window.matchMedia('(min-width: 769px) and (hover: hover) and (pointer: fine)');
function desktopSwatches() {
  return desktopHover.matches;
}
function linkedSwatch(target) {
  return target.closest && target.closest('#CollectionSection .custom-cross-prod a[data-src], #SearchResults .custom-cross-prod a[data-src]');
}
async function selectSwatch(swatch, fromHover = false) {
  const card = swatch.closest('.grid-product__content');
  const template = card && card.querySelector('template[data-plp-mobile-gallery]');
  if (!template) return;
  const destination = swatch.getAttribute('href');
  let state = selections.get(card);
  if (!state) {
    state = { originalId: template.dataset.productId, sequence: 0,
      controls: Array.from(card.closest('.grid-product').querySelectorAll('.quick-product__btn, .swym-button, [data-swaction], .color-swatch')).map(element => ({element, display: element.style.display, hidden: element.hidden})) };
    selections.set(card, state);
  }
  if (fromHover && state.pendingUrl === destination) return;
  if (state.abort) state.abort.abort();
  const sequence = ++state.sequence;
  if (fromHover && productPath(destination) === productPath(card.dataset.selectedProductUrl || template.dataset.productUrl)) {
    state.pendingUrl = null;
    card.removeAttribute('aria-busy');
    selectionStatus(card, 'Selected ' + card.querySelector('.grid-product__title').textContent + '.');
    return;
  }
  const abort = state.abort = new AbortController();
  state.pendingUrl = destination;
  card.setAttribute('aria-busy', 'true');
  setQuickAddPending(card, true);
  selectionStatus(card, 'Loading selected color.');
  const timeout = setTimeout(() => abort.abort(), 20000);
  try {
    const incoming = await fetchMedia(destination, abort.signal);
    const mask = card.querySelector('.grid-product__image-mask');
    const width = card.querySelector('.plp-mobile-gallery__track')?.clientWidth || mask.clientWidth;
    await prepareOpening(incoming, width, abort.signal);
    if (!card.isConnected || sequence !== state.sequence || abort.signal.aborted) return;
    if (!controllers.has(card)) initialize(template, true);
    const controller = controllers.get(card);
    if (!controller) throw new Error('Gallery unavailable');
    const title = card.querySelector('.grid-product__title');
    const price = card.querySelector('.grid-product__price');
    if (!title || !price) throw new Error('Card details unavailable');
    controller.replace(incoming, destination);
    const currentQuickAdd = card.querySelector('[data-plp-quick-add]');
    const incomingQuickAdd = incoming.quickAdd.querySelector('[data-plp-quick-add]');
    if (currentQuickAdd && incomingQuickAdd) currentQuickAdd.replaceWith(incomingQuickAdd.cloneNode(true));
    else if (currentQuickAdd) currentQuickAdd.remove();
    else if (incomingQuickAdd) card.querySelector('.plp-mobile-gallery').append(incomingQuickAdd.cloneNode(true));
    prepareQuickAdds(card);
    title.textContent = incoming.dataset.productTitle;
    price.replaceChildren(...incoming.productDetails.querySelector('[data-plp-price]').childNodes);
    card.querySelectorAll(':scope > .grid-product__tag').forEach(badge => badge.remove());
    card.prepend(...incoming.productDetails.querySelector('[data-plp-badges]').childNodes);
    card.querySelector('.plp-mobile-gallery').classList.toggle('plp-mobile-gallery--sold-out', incoming.dataset.productAvailable === 'false');
    card.querySelectorAll('a.grid-product__link').forEach(link => link.setAttribute('href', destination));
    // The original inert template remains a source for the original card; all live links use selected media.
    card.querySelectorAll('.custom-cross-prod a[data-src]').forEach(link => {
      const selected = link === swatch;
      link.classList.toggle('active', selected);
      if (selected) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
    });
    const switched = incoming.dataset.productId !== state.originalId;
    state.controls.forEach(({element, display, hidden}) => {
      element.hidden = switched || hidden;
      if (switched) element.style.setProperty('display', 'none', 'important');
      else if (display) element.style.display = display; else element.style.removeProperty('display');
    });
    if (incoming.cacheKey) {
      mediaCache.set(incoming.cacheKey, incoming.cacheHtml);
      if (mediaCache.size > 8) mediaCache.delete(mediaCache.keys().next().value);
    }
    card.dataset.selectedProductId = incoming.dataset.productId;
    card.dataset.selectedProductUrl = destination;
    card.dataset.selectedProductTitle = incoming.dataset.productTitle;
    card.dataset.selectedProductPrice = incoming.dataset.productPrice;
    selectionStatus(card, 'Selected ' + incoming.dataset.productTitle + '.');
  } catch (error) {
    if (card.isConnected && sequence === state.sequence) selectionStatus(card, 'Unable to load this color. Select its swatch to try again.');
  } finally {
    clearTimeout(timeout);
    if (sequence === state.sequence) { state.pendingUrl = null; card.removeAttribute('aria-busy'); setQuickAddPending(card, false); }
  }
}
const quickAddMobile = window.matchMedia('(max-width: 768px)');
function setQuickAddPending(card, pending) {
  const quickAdd = card.querySelector('[data-plp-quick-add]');
  if (!quickAdd) return;
  quickAdd.toggleAttribute('aria-busy', pending);
  quickAdd.querySelectorAll('.plp-quick-add__size:not(.is-unavailable)').forEach(size => { size.disabled = pending; });
  if (pending && quickAddMobile.matches) setQuickAddOpen(quickAdd, false);
}
function setQuickAddOpen(quickAdd, open) {
  if (!quickAdd) return;
  quickAdd.toggleAttribute('data-open', open);
  const toggle = quickAdd.querySelector('.plp-quick-add__toggle');
  const panel = quickAdd.querySelector('.plp-quick-add__panel');
  if (toggle) toggle.setAttribute('aria-expanded', String(open));
  if (panel) panel.setAttribute('aria-hidden', String(quickAddMobile.matches && !open));
}
function prepareQuickAdds(scope = root) {
  scope.querySelectorAll('[data-plp-quick-add]').forEach(quickAdd => {
    if (quickAddMobile.matches) setQuickAddOpen(quickAdd, false);
    else {
      quickAdd.removeAttribute('data-open');
      const panel = quickAdd.querySelector('.plp-quick-add__panel');
      if (panel) panel.setAttribute('aria-hidden', 'false');
    }
  });
}
function addQuickAddVariant(button) {
  const quickAdd = button.closest('[data-plp-quick-add]');
  const status = quickAdd.querySelector('.plp-quick-add__status');
  const variantId = button.dataset.variantId;
  if (!/^\d+$/.test(variantId || '') || !window.theme?.cart?.addItemFromForm || !window.jQuery) return;
  const buttons = quickAdd.querySelectorAll('.plp-quick-add__size:not(.is-unavailable)');
  buttons.forEach(size => { size.disabled = true; });
  quickAdd.setAttribute('aria-busy', 'true');
  button.classList.add('is-loading');
  if (status) status.textContent = 'Adding ' + button.textContent.trim() + ' to cart.';
  window.theme.cart.addItemFromForm('id=' + encodeURIComponent(variantId) + '&quantity=1')
    .then(() => {
      if (status) status.textContent = 'Added to cart.';
      window.jQuery('body').trigger('added.ajaxProduct');
      if (quickAddMobile.matches) setQuickAddOpen(quickAdd, false);
    })
    .catch(error => {
      const message = error?.responseJSON?.description || 'Unable to add this size. Please try again.';
      if (status) status.textContent = message;
    })
    .always(() => {
      quickAdd.removeAttribute('aria-busy');
      button.classList.remove('is-loading');
      buttons.forEach(size => { size.disabled = false; });
    });
}
root.addEventListener('click', event => {
  const control = event.target.closest && event.target.closest('[data-plp-quick-add] button');
  if (!control) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const quickAdd = control.closest('[data-plp-quick-add]');
  if (control.classList.contains('plp-quick-add__toggle')) {
    root.querySelectorAll('[data-plp-quick-add][data-open]').forEach(openQuickAdd => {
      if (openQuickAdd !== quickAdd) setQuickAddOpen(openQuickAdd, false);
    });
    setQuickAddOpen(quickAdd, !quickAdd.hasAttribute('data-open'));
  } else if (control.classList.contains('plp-quick-add__close')) {
    setQuickAddOpen(quickAdd, false);
  } else if (control.classList.contains('plp-quick-add__size') && !control.disabled) {
    addQuickAddVariant(control);
  }
}, true);
quickAddMobile.addEventListener('change', () => prepareQuickAdds());
prepareQuickAdds();
root.addEventListener('mouseover', event => {
  if (!desktopSwatches()) return;
  const swatch = linkedSwatch(event.target);
  if (!swatch || swatch.contains(event.relatedTarget)) return;
  const card = swatch.closest('.grid-product__content');
  if (!card || !card.querySelector('template[data-plp-mobile-gallery]')) return;
  // Also suppress the legacy image-only footer preview before proximity initialization.
  card.dataset.plpSwatchManaged = '';
  selectSwatch(swatch, true);
}, true);
root.addEventListener('click', event => {
  if (desktopSwatches()) return; // Desktop swatches retain their native PDP links.
  const swatch = linkedSwatch(event.target);
  if (!swatch || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const card = swatch.closest('.grid-product__content');
  if (!card || !card.querySelector('template[data-plp-mobile-gallery]')) return;
  event.preventDefault(); event.stopImmediatePropagation();
  selectSwatch(swatch);
}, true);
// Block app/theme actions that still carry the original product ID on a switched card.
root.addEventListener('click', event => {
  const control = event.target.closest && event.target.closest('.quick-product__btn, .swym-button, [data-swaction], .color-swatch');
  if (!control) return;
  const card = control.closest('.grid-product')?.querySelector('.grid-product__content'), state = card && selections.get(card);
  if (state && card.dataset.selectedProductId && card.dataset.selectedProductId !== state.originalId) {
    event.preventDefault(); event.stopImmediatePropagation();
  }
}, true);

mobile.addEventListener('change', refresh); refresh(); })();
// Isolated mobile disclosure: no product fetches or gallery state changes.
(() => {
  const root = (document.getElementById('CollectionAjaxResult') || document.getElementById('SearchResults'));
  if (!root) return;
  const mobile = window.matchMedia('(max-width: 768px)');
  function keepSelectedVisible(group) {
    const links = Array.from(group.querySelectorAll('a[data-src]'));
    const card = group.closest('.grid-product__content');
    const destination = card.dataset.selectedProductUrl || card.querySelector('template[data-plp-mobile-gallery]')?.dataset.productUrl;
    const selected = destination && links.find(link => new URL(link.href).pathname === new URL(destination, location.href).pathname);
    const visible = links.slice(0, 3);
    if (selected && !visible.includes(selected)) visible[2] = selected;
    links.forEach(link => link.toggleAttribute('data-plp-swatch-hidden', !visible.includes(link)));
  }
  root.addEventListener('click', event => {
    const button = event.target.closest && event.target.closest('[data-plp-swatch-toggle]');
    if (!button || !mobile.matches) return;
    event.preventDefault();
    event.stopPropagation();
    const group = button.closest('[data-plp-swatch-controls]');
    const expanded = !group.hasAttribute('data-plp-expanded');
    if (!expanded) keepSelectedVisible(group);
    group.toggleAttribute('data-plp-expanded', expanded);
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? 'Show Fewer' : '+' + button.dataset.moreCount;
    button.setAttribute('aria-label', expanded ? 'Show fewer colors' : 'Show ' + button.dataset.moreCount + ' more colors');
  });
  // A selection may finish after collapse, or while the viewport is desktop-sized.
  new MutationObserver(records => {
    records.forEach(record => {
      const group = record.target.querySelector('[data-plp-swatch-controls]:not([data-plp-expanded])');
      if (group && group.querySelector('[data-plp-swatch-toggle]')) keepSelectedVisible(group);
    });
  }).observe(root, { subtree: true, attributes: true, attributeFilter: ['data-selected-product-url'] });
})();
